import { motion } from "framer-motion";
import { FALLBACK, pick } from "@/lib/gallery";

const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSeDWOzfU3qlr2FKd9WMRpmklgr6HWSAqb5sbNPigvEGyjTnkg/viewform?embedded=true";

export default function Registration({ gallery }) {
  const posterSrc = pick(gallery?.image, FALLBACK.pendaftaran.image);
  return (
    <section
      id="pendaftaran"
      className="relative bg-parchment py-24 md:py-32"
      data-testid="registration-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        {/* Left visual */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-5"
        >
          <span className="text-xs tracking-[0.4em] uppercase text-gold">Pendaftaran Santri Baru</span>
          <h2 className="mt-4 font-serif-display text-forest text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            Daftarkan ananda<br />
            <span className="italic text-gold">menjadi penjaga Al-Qur&apos;an.</span>
          </h2>
          <p className="mt-6 text-moss leading-relaxed max-w-md">
            Isi Formulir di samping untuk mendaftarkan Ananda. Setelah submit
            akan ada link menuju chat WhatsApp ke Penguji Tahap 1 (Tilawah).
            Isi Formulir dengan data yang benar karena akan digunakan sebagai
            referensi untuk sesi Wawancara apabila Lulus di Tahap 1 (Tilawah).
          </p>

          <div className="mt-12 relative overflow-hidden rounded-2xl border border-gold/30 bg-forest">
            <img
              src={posterSrc}
              alt="Poster Penerimaan Santri Baru GRQ 2026 - 2027"
              className="w-full h-auto block"
              loading="lazy"
            />
          </div>
        </motion.div>

        {/* Right: embedded Google Form */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <div
            className="bg-white/60 backdrop-blur p-4 md:p-6 rounded-2xl border border-gold/30 overflow-hidden"
            data-testid="registration-form-embed"
          >
            <iframe
              src={GOOGLE_FORM_URL}
              title="Formulir Pendaftaran Santri Baru"
              className="w-full h-[1100px] md:h-[1200px] rounded-xl bg-white"
              style={{ border: 0 }}
              loading="lazy"
              data-testid="google-form-iframe"
            >
              Memuat formulir…
            </iframe>
            <p className="mt-3 text-xs text-moss text-center">
              Formulir tidak muncul?{" "}
              <a
                href="https://forms.gle/Bi2pSptsne1dKUW48"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold underline hover:text-forest transition-colors"
                data-testid="form-fallback-link"
              >
                Buka di tab baru
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
